export interface LogAuditoria {
  id: string;
  acao: string;
  modulo: 'atendimento' | 'financeiro' | 'empresas' | 'comunicados' | 'configuracoes' | 'auth' | 'dashboard';
  usuario: string;
  usuarioRole: string;
  detalhes: string;
  data: string;
  ip?: string;
  entidadeId?: string;
  entidadeTipo?: string;
}

export const logsAuditoria: LogAuditoria[] = [
  {
    id: 'LOG-001',
    acao: 'aprovar_operacao',
    modulo: 'financeiro',
    usuario: 'Carlos Mendes',
    usuarioRole: 'financeiro',
    detalhes: 'Aprovou saque PIX #OP-005 de R$ 850,00 para João Silva',
    data: '2026-05-08T14:32:00Z',
    ip: '192.168.1.105',
    entidadeId: 'OP-005',
    entidadeTipo: 'operacao',
  },
  {
    id: 'LOG-002',
    acao: 'rejeitar_operacao',
    modulo: 'financeiro',
    usuario: 'Carlos Mendes',
    usuarioRole: 'financeiro',
    detalhes: 'Rejeitou crédito de pontos #OP-007 - Motivo: Dados bancários incompletos',
    data: '2026-05-08T13:15:00Z',
    ip: '192.168.1.105',
    entidadeId: 'OP-007',
    entidadeTipo: 'operacao',
  },
  {
    id: 'LOG-003',
    acao: 'criar_operacao_manual',
    modulo: 'financeiro',
    usuario: 'Patricia Lima',
    usuarioRole: 'operador',
    detalhes: 'Criou operação manual de crédito de 1.500 pts para Empresa Inova Digital',
    data: '2026-05-08T11:45:00Z',
    ip: '192.168.1.110',
    entidadeId: 'EMP-002',
    entidadeTipo: 'empresa',
  },
  {
    id: 'LOG-004',
    acao: 'alterar_status_chamado',
    modulo: 'atendimento',
    usuario: 'Mariana Souza',
    usuarioRole: 'suporte',
    detalhes: 'Alterou status do chamado #SUP-001 de "aberto" para "em_andamento"',
    data: '2026-05-08T10:20:00Z',
    ip: '192.168.1.102',
    entidadeId: 'SUP-001',
    entidadeTipo: 'chamado',
  },
  {
    id: 'LOG-005',
    acao: 'atribuir_chamado',
    modulo: 'atendimento',
    usuario: 'Mariana Souza',
    usuarioRole: 'suporte',
    detalhes: 'Atribuiu chamado #SUP-003 para si mesma',
    data: '2026-05-08T09:55:00Z',
    ip: '192.168.1.102',
    entidadeId: 'SUP-003',
    entidadeTipo: 'chamado',
  },
  {
    id: 'LOG-006',
    acao: 'enviar_comunicado',
    modulo: 'comunicados',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Enviou comunicado "Atualização de Taxas de Resgate" para 1.884 destinatários',
    data: '2026-05-08T10:00:00Z',
    ip: '192.168.1.100',
    entidadeId: 'COM-001',
    entidadeTipo: 'comunicado',
  },
  {
    id: 'LOG-007',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Alterou taxa_processamento_pix de 2.5% para 2.0%',
    data: '2026-05-07T16:20:00Z',
    ip: '192.168.1.100',
    entidadeId: 'taxa_processamento_pix',
    entidadeTipo: 'configuracao',
  },
  {
    id: 'LOG-008',
    acao: 'ativar_empresa',
    modulo: 'empresas',
    usuario: 'Patricia Lima',
    usuarioRole: 'operador',
    detalhes: 'Ativou empresa Expresso Distribuidora (EMP-005) - cadastro aprovado',
    data: '2026-05-07T14:10:00Z',
    ip: '192.168.1.110',
    entidadeId: 'EMP-005',
    entidadeTipo: 'empresa',
  },
  {
    id: 'LOG-009',
    acao: 'suspender_empresa',
    modulo: 'empresas',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Suspendeu empresa Saúde Total (EMP-006) - Inadimplência no plano Básico',
    data: '2026-05-06T11:30:00Z',
    ip: '192.168.1.100',
    entidadeId: 'EMP-006',
    entidadeTipo: 'empresa',
  },
  {
    id: 'LOG-010',
    acao: 'login',
    modulo: 'auth',
    usuario: 'Carlos Mendes',
    usuarioRole: 'financeiro',
    detalhes: 'Login realizado com sucesso no backoffice',
    data: '2026-05-08T08:00:00Z',
    ip: '192.168.1.105',
  },
  {
    id: 'LOG-011',
    acao: 'adicionar_resposta',
    modulo: 'atendimento',
    usuario: 'Mariana Souza',
    usuarioRole: 'suporte',
    detalhes: 'Adicionou resposta ao chamado #SUP-002 - "Estamos verificando o problema de pontuação"',
    data: '2026-05-07T15:40:00Z',
    ip: '192.168.1.102',
    entidadeId: 'SUP-002',
    entidadeTipo: 'chamado',
  },
  {
    id: 'LOG-012',
    acao: 'logout',
    modulo: 'auth',
    usuario: 'Patricia Lima',
    usuarioRole: 'operador',
    detalhes: 'Logout realizado',
    data: '2026-05-07T18:00:00Z',
    ip: '192.168.1.110',
  },
  {
    id: 'LOG-013',
    acao: 'editar_empresa',
    modulo: 'empresas',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Editou dados da empresa TechBrasil (EMP-003) - Atualizou email e telefone',
    data: '2026-05-06T10:15:00Z',
    ip: '192.168.1.100',
    entidadeId: 'EMP-003',
    entidadeTipo: 'empresa',
  },
  {
    id: 'LOG-014',
    acao: 'aprovar_operacao',
    modulo: 'financeiro',
    usuario: 'Carlos Mendes',
    usuarioRole: 'financeiro',
    detalhes: 'Aprovou estorno #OP-004 de R$ 450,00 para Empresa getPoints',
    data: '2026-05-06T09:30:00Z',
    ip: '192.168.1.105',
    entidadeId: 'OP-004',
    entidadeTipo: 'operacao',
  },
  {
    id: 'LOG-015',
    acao: 'login_falha',
    modulo: 'auth',
    usuario: 'Desconhecido',
    usuarioRole: '-',
    detalhes: 'Tentativa de login falhou - Email não encontrado: hacker@email.com',
    data: '2026-05-05T22:45:00Z',
    ip: '203.45.67.89',
  },
  {
    id: 'LOG-016',
    acao: 'enviar_comunicado',
    modulo: 'comunicados',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Agendou comunicado "Manutenção Programada" para 07/05 às 02:00',
    data: '2026-05-05T14:00:00Z',
    ip: '192.168.1.100',
    entidadeId: 'COM-003',
    entidadeTipo: 'comunicado',
  },
  {
    id: 'LOG-017',
    acao: 'alterar_status_chamado',
    modulo: 'atendimento',
    usuario: 'Mariana Souza',
    usuarioRole: 'suporte',
    detalhes: 'Alterou status do chamado #SUP-004 para "resolvido"',
    data: '2026-05-05T11:00:00Z',
    ip: '192.168.1.102',
    entidadeId: 'SUP-004',
    entidadeTipo: 'chamado',
  },
  {
    id: 'LOG-018',
    acao: 'criar_operacao_manual',
    modulo: 'financeiro',
    usuario: 'Carlos Mendes',
    usuarioRole: 'financeiro',
    detalhes: 'Criou débito de 500 pts para participante Ana Paula - Motivo: Correção de duplicidade',
    data: '2026-05-04T16:30:00Z',
    ip: '192.168.1.105',
    entidadeId: 'PART-234',
    entidadeTipo: 'participante',
  },
  {
    id: 'LOG-019',
    acao: 'login',
    modulo: 'auth',
    usuario: 'Mariana Souza',
    usuarioRole: 'suporte',
    detalhes: 'Login realizado com sucesso',
    data: '2026-05-08T08:15:00Z',
    ip: '192.168.1.102',
  },
  {
    id: 'LOG-020',
    acao: 'alterar_configuracao',
    modulo: 'configuracoes',
    usuario: 'André Costa',
    usuarioRole: 'admin',
    detalhes: 'Alterou limite_resgate_diario de R$ 1.000,00 para R$ 1.500,00',
    data: '2026-05-03T11:00:00Z',
    ip: '192.168.1.100',
    entidadeId: 'limite_resgate_diario',
    entidadeTipo: 'configuracao',
  },
];

export const modulosAuditoria = [
  { id: 'todos', label: 'Todos' },
  { id: 'atendimento', label: 'Atendimento' },
  { id: 'financeiro', label: 'Financeiro' },
  { id: 'empresas', label: 'Empresas' },
  { id: 'comunicados', label: 'Comunicados' },
  { id: 'configuracoes', label: 'Configurações' },
  { id: 'auth', label: 'Autenticação' },
];

export const acoesAuditoria = [
  { id: 'aprovar_operacao', label: 'Aprovar Operação', icon: 'ri-check-line', color: 'text-emerald-600', bg: 'bg-emerald-50' },
  { id: 'rejeitar_operacao', label: 'Rejeitar Operação', icon: 'ri-close-line', color: 'text-red-600', bg: 'bg-red-50' },
  { id: 'criar_operacao_manual', label: 'Operação Manual', icon: 'ri-exchange-dollar-line', color: 'text-blue-600', bg: 'bg-blue-50' },
  { id: 'alterar_status_chamado', label: 'Alterar Status Chamado', icon: 'ri-flag-line', color: 'text-amber-600', bg: 'bg-amber-50' },
  { id: 'atribuir_chamado', label: 'Atribuir Chamado', icon: 'ri-user-add-line', color: 'text-purple-600', bg: 'bg-purple-50' },
  { id: 'adicionar_resposta', label: 'Nova Resposta', icon: 'ri-chat-3-line', color: 'text-cyan-600', bg: 'bg-cyan-50' },
  { id: 'enviar_comunicado', label: 'Enviar Comunicado', icon: 'ri-send-plane-line', color: 'text-indigo-600', bg: 'bg-indigo-50' },
  { id: 'alterar_configuracao', label: 'Alterar Configuração', icon: 'ri-settings-line', color: 'text-gray-600', bg: 'bg-gray-50' },
  { id: 'ativar_empresa', label: 'Ativar Empresa', icon: 'ri-checkbox-circle-line', color: 'text-emerald-600', bg: 'bg-emerald-50' },
  { id: 'suspender_empresa', label: 'Suspender Empresa', icon: 'ri-pause-circle-line', color: 'text-orange-600', bg: 'bg-orange-50' },
  { id: 'editar_empresa', label: 'Editar Empresa', icon: 'ri-pencil-line', color: 'text-blue-600', bg: 'bg-blue-50' },
  { id: 'editar_perfil_usuario', label: 'Editar Perfil Usuário', icon: 'ri-user-settings-line', color: 'text-teal-600', bg: 'bg-teal-50' },
  { id: 'login', label: 'Login', icon: 'ri-login-box-line', color: 'text-emerald-600', bg: 'bg-emerald-50' },
  { id: 'logout', label: 'Logout', icon: 'ri-logout-box-r-line', color: 'text-gray-600', bg: 'bg-gray-50' },
  { id: 'login_falha', label: 'Login Falhou', icon: 'ri-error-warning-line', color: 'text-red-600', bg: 'bg-red-50' },
];

export function getAcaoConfig(acaoId: string) {
  return acoesAuditoria.find((a) => a.id === acaoId) || {
    label: acaoId,
    icon: 'ri-file-list-line',
    color: 'text-gray-600',
    bg: 'bg-gray-50',
  };
}

export function getModuloLabel(moduloId: string): string {
  const m = modulosAuditoria.find((x) => x.id === moduloId);
  return m?.label || moduloId;
}

export function getModuloColor(moduloId: string): string {
  switch (moduloId) {
    case 'financeiro': return 'bg-emerald-100 text-emerald-700';
    case 'atendimento': return 'bg-blue-100 text-blue-700';
    case 'empresas': return 'bg-purple-100 text-purple-700';
    case 'comunicados': return 'bg-indigo-100 text-indigo-700';
    case 'configuracoes': return 'bg-gray-100 text-gray-700';
    case 'auth': return 'bg-amber-100 text-amber-700';
    default: return 'bg-gray-100 text-gray-600';
  }
}